import { Button } from 'antd';
import styled from 'styled-components';

import { MpParagraph } from 'shared/ui/MpParagraph';

export const BannerContainerStyled = styled.div`
	position: relative;

	margin-top: 16px;
	padding: 24px;

	background-color: #f0f5ff;
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		width: calc(100vw - 32px);
		height: 256px;
		padding: 16px;
		margin: 40px 16px 0 16px;
	}

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		width: 496px;
		height: 288px;
		padding: 24px;
		margin: 0 auto;
		margin-top: 40px;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		width: 688px;
		height: 232px;
		padding: 24px;
		margin-top: 32px;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		width: 916px;
		height: 208px;
		padding: 24px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		width: 1200px;
		height: 208px;
		padding: 24px;
	}
`;

export const BannerHeaderStyled = styled.h2`
	margin-bottom: 16px;
	font-size: 24px;
	line-height: 32px;
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		max-width: 293px;
		font-size: 20px;
		line-height: 28px;
	}

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		max-width: 293px;
		font-size: 24px;
		line-height: 32px;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		max-width: 403px;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		max-width: 531px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		max-width: 680px;
	}
`;

export const BannerTextStyled = styled(MpParagraph)`
	margin-bottom: 24px;

	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		max-width: 293px;
	}

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		max-width: 293px;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		max-width: 403px;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		max-width: 531px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		max-width: 680px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		max-width: 680px;
	}
`;

export const BannerImgStyled = styled.img`
	position: absolute;
	top: 0;
	right: 0;
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		display: none;
	}

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		display: none;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		display: none;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		display: block;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		display: block;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		display: block;
	}
`;

export const BannerImgTStyled = styled.img`
	position: absolute;
	top: 0;
	right: 0;
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		display: none;
	}

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		display: none;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		display: block;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		display: none;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		display: none;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		display: none;
	}
`;

export const BannerImgMStyled = styled.img`
	position: absolute;
	top: 0;
	right: 0;
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		display: none;
	}

	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		display: block;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		display: none;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		display: none;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		display: none;
	}

	@media (min-width: ${props => props.theme.breakpoints.xxl}) {
		display: none;
	}
`;

export const ButtonStyled = styled(Button)`
	width: 100%;
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		width: 172px;
	}
`;
